import { render, staticRenderFns } from "./EmojiReactions.vue?vue&type=template&id=dea908e6&scoped=true&"
import script from "./EmojiReactions.vue?vue&type=script&lang=js&"
export * from "./EmojiReactions.vue?vue&type=script&lang=js&"
import style0 from "./EmojiReactions.vue?vue&type=style&index=0&id=dea908e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea908e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VCard,VImg,VMenu})
